import styled from 'styled-components'
import Image from 'next/image'

const LoadMoreBoxStyled = styled.div`
  width: 300px;
  background: rgb(236, 236, 236);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 20px;
`

const LoadMoreBox = ({ loading, freshOut, ...props }) => {
  let image = loading ? 'running' : 'paint-roller'
  if (freshOut) image = 'folder-empty'

  let text = loading ? 'LOADING...' : 'LOAD MORE'
  if (freshOut) text = 'THAT\'S ALL, FOLKS!'

  return (
    <LoadMoreBoxStyled {...props}>
      <Image src={`/img/${image}.svg`} height={75} width={75} />

      <h3>{text}</h3>
    </LoadMoreBoxStyled>
  )
}

export default LoadMoreBox
